<template>
<div class="section">
  <div class="section__header">
    <h2>Архив-каталог домашнего задания</h2>
    <back></back>
  </div>

  <div class="section__body">
    <div class="form">
      <p class="form__field">
        <select 
          v-model="selected_trainer"
          @change="getHomeworkArchive"
          class="required"
          :class="{
            valid: selected_trainer,
            invalid: !selected_trainer,
          }"
        >
          <option value="" selected disabled>Выберите тренажер</option>
          <option value="book">Чтение книги</option>
          <option v-for="(val, key) in trainers" :key="val.id" :value="key">{{ val }}</option>
        </select>
      </p>

      <p class="form__field">
        <select 
          v-model="selected_class"
          @change="getHomeworkArchive"
          class="required"
          :class="{
            valid: selected_class,
            invalid: !selected_class,
          }"
        >
          <option value="" selected disabled>Выберите класс</option>
          <option v-for="(val, key) in classes" :key="val.id" :value="key">{{ val }}</option>
        </select>
      </p>
    </div>
    <div class="homeworks" v-if="items.length">
      <HwArcItem v-for="item in items" :item="item" :key="item.id" />
    </div>
    <div v-else class="homeworks">
      <small>Данные не найдены. Выберите необходимые параметры в настройках</small>
    </div>
  </div>
</div>
</template>

<script>
import HwArcItem from './HwArcItem'
import { mapGetters } from 'vuex'

export default {
  name: "hw-archive",
  inject: ['http'],
  components: {
    HwArcItem
  },
  data() {
    return {
      trainers: '',
      classes: '',
      selected_trainer: '',
      selected_class: '',
      items: '',
    }
  },
  computed: {
    ...mapGetters({
      user: 'user'
    })
  },
  methods: {
    init() {
      let data = {
        user_id: this.user.id
      }
      this.http.post('onGetHwArchData', data).then(res => {
        this.trainers = res.data.trainers;
        this.classes = res.data.classes;
      });      
    },
    getHomeworkArchive() {
      if (this.selected_trainer && this.selected_class) {
        let data = {
          trainer_id: this.selected_trainer,
          user_id: this.user.id,
          class_id: this.selected_class
        };
        this.http.post('onGetHwByTrainerId', data).then(res => {
          this.items = res.data
        });
      }     
    }
  },
  mounted() {
    this.init();
  }
}
</script>

<style lang="scss" scoped>
.form {
  max-width: 300px;
}
.homeworks {
  width: 100%;
  margin-top: 40px;
  text-align: center;
}
</style>
